import { useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Footer from "../components/Footer";
import Header from "../components/use-cases/Header";
import CaseItem from "../components/use-cases/CaseItem";
import NavigationButtons from "../components/use-cases/NavigationButtons";
import { useCasesData } from "../components/use-cases/UseCasesData";

gsap.registerPlugin(ScrollTrigger);

const UseCases = () => {
  const component = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Any remaining GSAP animations for the entire page can go here
    }, component);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={component} className="min-h-screen bg-[#F8FAFF]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-24 md:pb-32">
        <Header />
        
        <h2 className="font-medium text-center mb-12 md:mb-24 md:text-5xl lg:text-7xl px-4 md:px-0 text-2xl">Risolto con applicazioni concrete</h2>
        
        <div className="max-w-5xl mx-auto space-y-6 md:space-y-8">
          {useCasesData.map((useCase, index) => (
            <CaseItem
              key={index}
              title={useCase.title}
              description={useCase.description}
              media={useCase.media}
              isActive={true}
              index={index}
            />
          ))}
        </div>

        {/* Call to Action */}
        <div className="max-w-3xl mx-auto text-center mt-16 md:mt-24 mb-8">
          <h3 className="text-2xl md:text-3xl font-medium mb-4 text-[#8B5CF6]">
            Non è tutto qui!
          </h3>
          <p className="text-gray-600 text-lg md:text-xl font-light">
            Molte altre funzionalità devono ancora arrivare. Resta aggiornato per scoprire tutte le potenzialità di Vertigo.
          </p>
        </div>
      </div>

      <NavigationButtons />
      <Footer />
    </div>
  );
};

export default UseCases;
